import React from "react";
import Layout from "../layouts/Default";
import EditBar from "../parts/EditBar";
import Icon from "@mdi/react";
import { mdiMapMarker, mdiAccountSupervisor, mdiArrowLeft } from "@mdi/js";
import Avatar from "../components/avatar/Avatar";
import Text from "../components/typography/Text";
import fetchApi from "../fetchApi";
import AuthContext from "../contexts/auth";
import Links from "../components/links/Links";
import useMedia from "../hooks/useMedia";
import Button from "../components/buttons/Button";
import Loader from "../components/loaders/Loader";
import Mission from "../parts/Project/Mission";
import NotFound from "./404";

const Project = ({ location, match, history }) => {
  const { user, authState } = React.useContext(AuthContext);
  const { slug, missionId } = match.params;
  const media = useMedia();
  const [showDetails, toggleDetails] = React.useReducer(s => !s, false);
  const loggedUser = user ? user.slug === slug : false;
  const [loading, setLoading] = React.useState(true);
  const [project, setProject] = React.useState(
    location.state ? location.state.project : null
  );
  const [mission, setMission] = React.useState();

  const fetchProject = React.useMemo(
    () => async () => {
      setLoading(true);
      try {
        const [fetchedProject] = await fetchApi(`/users?slug=${slug}`);
        setProject(fetchedProject);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
    [slug]
  );

  React.useEffect(() => {
    fetchProject();
  }, [fetchProject]);

  React.useEffect(() => {
    fetchApi(`/mission/${missionId}`)
      .then(fetchedMission => {
        if (fetchedMission?.id) setMission(fetchedMission);
        else throw Error(fetchedMission);
      })
      .catch(console.error);
  }, [missionId]);

  if (loading || !project)
    return (
      <Layout title="Loading...">
        <div style={{ marginBottom: "60px" }} />
        <Loader />
      </Layout>
    );
  else if (!authState) return <NotFound />;

  return (
    <Layout
      title={project.company}
      topBar={
        loggedUser ? (
          <EditBar
            actionLabel="Post design job"
            actionLink="/project/editmission"
          />
        ) : null
      }
    >
      <div className="pProject">
        <div className={`pProject_profile ${loggedUser ? "-logged" : ""}`}>
          <div className="pProject_part -header">
            <div className="pProject_picture">
              <Avatar avatar={project.avatar} />
            </div>
            <div className="pProject_name">
              <h4>{project.company}</h4>
            </div>
            {project?.ecosystem && (
              <div className="pProject_ecosystem">{project.ecosystem}</div>
            )}

            <div className="pProject_buttons">
              {media === "mobile" && (
                <Button outlined onClick={toggleDetails} rounded>
                  Show details
                </Button>
              )}
            </div>
          </div>

          {(media !== "mobile" || showDetails) && (
            <div className="pProject_details">
              <div className="pProject_part -contact">
                <Text small>Contact person</Text>
                <h5>
                  {project.contact_name}, {project.contact_job}
                </h5>
              </div>
              <div className="pProject_part">
                <h5>
                  <Icon path={mdiMapMarker} size="19px" />
                  {project.city}, {project.country}
                </h5>
                <h5>
                  <Icon path={mdiAccountSupervisor} size="19px" />
                  {project.company_size} people
                </h5>
              </div>
              <div className="pProject_part">
                <Links {...project} />
              </div>
            </div>
          )}
        </div>
        <div className="pProject_content">
          <a className="pProject_back" href={`/project/${slug}`}>
            <Icon path={mdiArrowLeft} size="16px" />
            Back to job description
          </a>
          {mission && (
            <Mission
              key={mission.id}
              loggedUser={loggedUser}
              mission={mission}
              refresh={() =>
                history.push({
                  pathname: `/project/${slug}`,
                })
              }
              canApply={false}
              projectSlug={slug}
              showAllApplications
            />
          )}
          {!mission && <Text>Mission not found</Text>}
        </div>
      </div>
    </Layout>
  );
};

export default Project;
